import {Signal} from "@preact/signals-react";
import {signal} from "@preact/signals-core";

export const s_app_sl: Signal<boolean> = signal(false);
export const s_app_mobile: Signal<boolean> = signal(false);
export const s_app_mobile_tab: Signal<string> = signal('');
export const s_app_cid: Signal<string> = signal('');
export const s_app_rid: Signal<string> = signal('');
export const s_app_uid: Signal<string> = signal('');
export const s_app_toggleMobile = () => {
    let mobile = localStorage.getItem('mobile') === "1";
    const toggle = !mobile;
    localStorage.setItem('mobile', mobile ? "0" : "1");
    s_app_mobile.value = toggle
    s_app_mobile_tab.value = toggle ? "char" : "";
}

